export const LouisVuittonThemePreset = {
  semantic: {
    primary: {
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#E6E6E6',
      300: '#D3D3D3',
      400: '#A3A3A3',
      500: '#727272',
      600: '#535353',
      700: '#404040',
      800: '#272727',
      900: '#1D1D1D', //main color
      950: '#0B0B0B',
    },
    colorScheme: {
      light: {
        primary: {
          color: "{primary.900}",
          contrastColor: "{surface.0}",
          hoverColor: "{primary.700}",
          activeColor: "{primary.600}",
          gradient: "45deg, {primary.900} 0%, {primary.800} 49.5%, {primary.900} 100%",
          shadow: "0px 5px 20px -5px {primary.700}",
        }
      }
    }
  }
};
